import React from 'react';
import { Button } from '../../../button/export';
import * as styles from './style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Controls = _ref => {
  var onClearClick = _ref.onClearClick,
    onCloseClick = _ref.onCloseClick;
  return ___EmotionJSX("div", {
    css: styles.controls
  }, ___EmotionJSX(Button, {
    appearance: "link",
    css: styles.clearButton,
    onClick: onClearClick
  }, "Clear"), ___EmotionJSX(Button, {
    appearance: "muted",
    size: "small",
    onClick: onCloseClick
  }, "Done"));
};
export default Controls;